import React, { useState } from "react";
import { FaUserEdit, FaTimes } from "react-icons/fa";
import Customer from "../../models/Customer";

interface GuestInfoModalProps {
    guest: Customer;
    onClose: () => void;
    onSave: (updatedGuest: any) => Promise<void>;
}

export const GuestInfoModal: React.FC<GuestInfoModalProps> = ({
    guest,
    onClose,
    onSave,
}) => {
    const [formData, setFormData] = useState(guest);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        await onSave(formData);
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-2 sm:px-0">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                >
                    {FaTimes({ size: 18 })}
                </button>

                <div className="flex items-center gap-2 mb-4">
                    <span className="text-blue-600" >{FaUserEdit({ size: 18 })}</span>
                    <h2 className="text-lg font-semibold text-gray-900">Guest Information</h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <Input label="Full Name" name="name" value={formData.name ?? ""} onChange={handleChange} />
                    <Input label="Phone" name="phone" value={formData.phone || ""} onChange={handleChange} />
                    <Input label="Email" name="email" value={formData.email || ""} onChange={handleChange} />
                    <Input label="Address" name="address" value={formData.address || ""} onChange={handleChange} />
                    <Select label="Gender" name="gender" value={formData.gender || ""} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </Select>
                    <Input label="Occupation" name="occupation" value={formData.occupation || ""} onChange={handleChange} />
                    <Input label="Nationality" name="nationality" value={formData.nationality || ""} onChange={handleChange} />
                    <Input label="State" name="state" value={formData.state || ""} onChange={handleChange} />
                    <Input label="Vehicle No." name="vechicleNo" value={formData.vechicleNo || ""} onChange={handleChange} />
                    <Select label="ID Type" name="idType" value={formData.idType || ""} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="nin">NIN</option>
                        <option value="passport">International Passport</option>
                        <option value="driversLicence">Driver’s License</option>
                        <option value="votersCard">Voter’s Card</option>
                    </Select>
                    <Input label="ID Number" name="idNumber" value={formData.idNumber || ""} onChange={handleChange} />
                </div>

                <div className="flex justify-end gap-3 mt-5">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-gray-800 font-medium"
                        // disabled={isSaving}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-md text-white font-medium"
                        // disabled={isSaving}
                    >
                        {/* {isSaving ? "Saving..." : "Save Changes"} */}
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

const Input = ({
    label,
    name,
    value,
    onChange,
}: {
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => (
    <div className="flex flex-col">
        <label className="text-sm text-gray-600 mb-1">{label}</label>
        <input
            type="text"
            name={name}
            value={value}
            onChange={onChange}
            className="border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none text-sm"
        />
    </div>
);

const Select = ({
    label,
    name,
    value,
    onChange,
    children,
}: {
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    children: React.ReactNode;
}) => (
    <div className="flex flex-col">
        <label className="text-sm text-gray-600 mb-1">{label}</label>
        <select
            name={name}
            value={value}
            onChange={onChange}
            className="border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none text-sm"
        >
            {children}
        </select>
    </div>
);